import BaseApiRequestService from './BaseApiRequestService';

class CirgsApiRequestService extends BaseApiRequestService {
  protected readonly serviceURL = window.location.host.startsWith('localhost') ? 'http://localhost:3089' : 'https://439zisrgu2.execute-api.us-east-1.amazonaws.com/prod/cirgs';
}

export default new CirgsApiRequestService();
